import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Type } from '@nerdwallet/currency';

import ImageHero from '../image-hero/image-hero';
import CompanyHeader from './company-header/company-header';
import CompanyStroke from '../company-stroke/company-stroke';
import CompanyDepartments from './company-departments/company-departments';
import MeetNerds from './company-meet-nerds/company-meet-nerds';

import ImageHeroContent from '../../lib/company-content-src/image-hero-content';
import MeetNerdsData from '../../lib/company-content-src/company-meet-nerds-content';
import MeetNerdsDataDesktop from '../../lib/company-content-src/company-meet-nerds-content-desktop';

const CareersPage = ({ careersData }) => (
  <Fragment>
    <ImageHero
      preheader={ImageHeroContent.careers.preheader}
      title={ImageHeroContent.careers.title}
      body={ImageHeroContent.careers.body}
      bodyMobile={ImageHeroContent.careers.bodyMobile}
      buttonText={ImageHeroContent.careers.buttonText}
      backgroundClassName={ImageHeroContent.careers.backgroundClassName}
    />
    <CompanyHeader headerText="Careers By Team" />
    <CompanyDepartments departments={careersData.departments} />
    <CompanyStroke />
    <div
      className={classNames([
        classes('width-auto'),
        classes('text-align-center'),
        classes('margin-vertical-5'),
        classes('margin-horizontal-3'),
      ])}
    >
      <CompanyHeader headerText="Meet Our Nerds" />
      <div>
        <div
          className={classNames([
            classes('display-block'),
            classes('display-none--wide'),
          ])}
        >
          <MeetNerds {...MeetNerdsData} />
        </div>
        <div
          className={classNames([
            classes('display-none'),
            classes('display-block--wide'),
          ])}
        >
          <MeetNerds {...MeetNerdsDataDesktop} />
        </div>
      </div>
    </div>
    <CompanyStroke />
    <div
      className={classNames([
        classes('width-auto'),
        classes('text-align-center'),
        classes('margin-vertical-5'),
        classes('margin-horizontal-3'),
      ])}
    >
      <Type
        gotham
        size="3"
        className={classNames([
          classes('display-none--wide'),
          classes('max-width-prose'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        Be a part of life at NerdWallet.
        <br />
        Join our team.
      </Type>
      <Type
        gotham
        size="3"
        className={classNames([
          classes('display-none'),
          classes('display-block--wide'),
          classes('max-width-prose-wide'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        Follow us on LinkedIn for more info about life at NerdWallet
      </Type>
      <Button primary href="https://www.linkedin.com/company/nerdwallet">
        Click here
      </Button>
    </div>
  </Fragment>
);

CareersPage.displayName = 'Careers Page';

CareersPage.propTypes = {
  careersData: PropTypes.shape({
    departments: PropTypes.arrayOf(
      PropTypes.shape(CompanyDepartments.propTypes)
    ),
  }),
};

export default CareersPage;
